import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import * as S from './ErrorBoundary.css';
export class ErrorBoundary extends PureComponent {
    constructor(props) {
        super(props);
        this.render = () => this.state.error ? (_jsx(S.ErrorContainer, { children: _jsxs(S.ErrorHeader, Object.assign({ variant: "h2" }, { children: [_jsx(Box, Object.assign({ mb: 10 }, { children: "We apologize, an error has occured on our side while handling this activity." })), "Please reload the page, and if you continue to see this error, please contact Tillit team (Slack channel \"nt-tillit\")."] })) })) : (this.props.children);
        this.state = {};
    }
    componentDidUpdate(prevProps) {
        if (prevProps.location.key !== this.props.location.key &&
            this.state.error !== undefined) {
            this.setState({ error: undefined, info: undefined });
        }
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
}
export default withRouter(ErrorBoundary);
